import { Capacitor, registerPlugin } from '@capacitor/core';
import { META_NATIVE_SIGNUP_PATH } from './MetaNativeSignupConfig';

export { META_NATIVE_SIGNUP_PATH, META_NATIVE_SIGNUP_URL, META_NATIVE_API } from './MetaNativeSignupConfig';
const PENDING_KEY = 'xeguei.whatsapp-meta.pending';
const UUID = /^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i;

interface NativeSignupPlugin {
  open(options: { url: string; sessionId: string }): Promise<{ status: 'returned' | 'cancelled'; sessionId: string }>;
  close(options: { sessionId: string }): Promise<void>;
}

const plugin = registerPlugin<NativeSignupPlugin>('WhatsAppMetaSignup');
export const isNativeMetaSignup = () => Capacitor.isNativePlatform();

export function openNativeMetaSignup(url: string, sessionId: string) {
  const target = new URL(url);
  if (target.origin !== 'https://empresa.xeguei.com.br' || target.pathname !== META_NATIVE_SIGNUP_PATH
    || target.username || target.password || target.search || !target.hash || !UUID.test(sessionId)) {
    return Promise.reject(new Error('Endereço de autorização inválido.'));
  }
  return plugin.open({ url, sessionId });
}

export function closeNativeMetaSignup(sessionId: string) {
  return plugin.close({ sessionId }).catch(() => undefined);
}

export type PendingNativeSignup = { sessionId: string; empresaId: string; expiresAt: string };

// Only correlation data survives an app restart; never persist the handoff secret or Meta code.
export function rememberNativeSignup(pending: PendingNativeSignup) {
  try { localStorage.setItem(PENDING_KEY, JSON.stringify(pending)); } catch (_) { /* Memory flow still works. */ }
}

export function readPendingNativeSignup(): PendingNativeSignup | null {
  try {
    const value = JSON.parse(localStorage.getItem(PENDING_KEY) || 'null');
    return value && UUID.test(value.sessionId) && typeof value.empresaId === 'string'
      && Number.isFinite(Date.parse(value.expiresAt)) ? value : null;
  } catch (_) { return null; }
}

export function forgetNativeSignup(sessionId: string) {
  if (readPendingNativeSignup()?.sessionId !== sessionId) return;
  try { localStorage.removeItem(PENDING_KEY); } catch (_) { /* No credentials are stored here. */ }
}
